// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

import {IThreat} from './threat';

export class PartnerTypes {
    public static readonly THIRD_PARTY = 0;
    public static readonly CARBON_BLACK = 1;
    public static readonly CYBERARK_EPM = 2;
    public static readonly SOPHOS = 3;
    public static readonly CISCO_DUO = 4;
    public static readonly CISCO_AMP = 5;
    public static readonly ACTIVE_DIRECTORY = 6;
    public static readonly SENTINEL_ONE = 7;
    public static readonly CIGENT_TESTING = 8;
    public static readonly OKTA = 9;
}

export class AzureIntegratonSource {
    public static readonly CIGENT_APP = 0;
    public static readonly AZURE_SERVICE = 1;
}

export interface IIntegrationStatus {
    id: number;
    integration_id: number;
    config_id: number;
    group_id: number;
    display_name: string;
    threat_reported: number;
    reviving: number;
    last_heartbeat: string;
    last_http_status: number;
}

export interface IIntegrationStatusResponse {
    enabled: boolean;
    integrationStatus: IIntegrationStatus;
    threats: IThreat[];
}

export interface IIntegration {
    id?: string;
    admin_email?: string;
    enabled?: boolean;
    display_name?: string;
    secret?: string;

    config: {

        // common attributes
        secret_key?: string;
        api_url?: string;
        admin_unlock?: boolean;
        lock_option?: string;

        // Third Party (API only)
        description?: string;
        sensorType?: number;

        // Carbon Black
        org_key?: string;
        device_url?: string;
        siem_api_id?: string;
        siem_secret_key?: string;
        watchlist_severity?: number;
        policy_severity?: number;
        rules?: string[];

        // CyberArk
        login_url?: string;
        username?: string;
        password?: string;
        application_id?: string;

        // Sophos Endpoint
        client_id?: string;  // also used by Okta
        client_secret?: string;
        tenant_id?: string;

        // Cicso AMP Endpoint
        api_key?: string;
        // client_id already defined by Sophos above ^
        unique_id?: string;  // appended to event stream name
        amp_api_host?: string;

        // Cisco Duo
        integration_key?: string;
        api_hostname?: string;
        runtime_config?: {
            'amp_queue_name'?: string
        }

        // Active Directory
        // tenant_id?: string; // defined above in sophose
        groups?: [IActiveDirectoryGroup];
        enable_all?: boolean;
        source?: number;  // defines 0 (or undefined) as cigent, 1 as azure service

        // Okta
        oktaDomain?: string; // URL to redirect to (Okta's terminology)
        oktaClientId?: string; // URL to redirect to (Okta's terminology)
        oktaServerId?: string;
        oktaDefaultRole?: string;

        // Sentinal One
        api_token?: string;

        // Cigent Testing
        // Device name that will have a threat raised.
        device_name?: string;
        send_at_start?: boolean;
        send_every_loop?: boolean;
    };
    partner_id: number;
}

export interface IActiveDirectoryGroup {
    group_id: string;
    role: string;  // value of 'user' or 'admin'
}

export interface ICreateIntegrationResponse {
    new_id: number;
}

export interface IIntegrationsPageConfig {
    carbon_black_button: boolean;
    sophos_button: boolean;
    cisco_amp_button: boolean;
    cisco_duo_button: boolean;
    cisco_duo_button_disabled: boolean;
}

export interface IIntegrationsResponse {
    integrations: IIntegration[];
}

export interface IValidationResponse {
    status_code: number;
    data: any;
    error: string;
}

export interface ISophosTenantsResponse {
    error: string;
    status: string;
    tenants: ITenant[];
}

export interface ISentinelOneValidationResponse {
    status: number;
    agentCount: number;
}

export interface ITenant {
    id: string;
    name: string;
    apiHost: string;
}
